import mixinActions from '../core/actions';
import mixinGetters from '../core/getters/index';
import feedGetters from '../core/getters/feed';
import mixinMutations from '../core/mutations/index';
import feedMutations from '../core/mutations/feed';
import constants from 'Helpers/constants';
import feedActions from '~/store/core/actions/feed';

export default {
    namespaced: true,
    state: {
        response: [],
        liveBotFeeds: [],
        extraFeeds: [],
        repositoryName: 'liveBotFeeds',
        marketName: 'liveBotFeed',
        version: 0,
        filters: {
            line: constants.LINE_MAIN,
            customLeagueIds: null,
            marketId: constants.DBALL_MARKET_LIVE,
            leagueGroupId: [],
            periodTypeId: constants.GAME_PERIOD_FT,
            customEventId: null,
            search: null,
            betCustomEventIds: [], //Open BetDialogs
            isPositionOnly: false,
        },
        liveBotFeedLeague: {},
        liveBotFeedTeam: {},
        isShowExtraFilters: false,
        gamesIdx: { liveBotFeeds: [] },
    },

    mutations: {
        ...mixinMutations(),
        ...feedMutations('FeedLiveBotModule'),
    },

    getters: {
        ...mixinGetters(),
        ...feedGetters(),
        getFeedLeague(state) {
            return state.liveBotFeedLeague;
        },
        getFeedTeam(state) {
            return state.liveBotFeedTeam;
        },
    },

    actions: {
        ...mixinActions('feedLiveBot'),
        ...feedActions('feedLiveBot'),
    },
};
